import React, { useEffect, useState } from 'react';
import Tabs, { TabItem } from '../../../../common/components/xepp/tab/Tabs';
import BillPageLayout from '../component/layout/BillPageLayout';
import CountryTab from './CreateCountryTab';
import { UtilityPage } from './UtilityPage';
import { useGetCountriesQuery } from '../../../../service/utility-service';
import { toast } from 'react-toastify';
import { getErrorMessage } from '../../../../utils/error-handler';
import { useConfigLayout } from '../../../../hooks/useConfigLayout';



const SettingsPage: React.FC = () => {
  const { data, isLoading, isError, error} = useGetCountriesQuery();
  const [selectedCountry, setSelectedCountry] = useState<number | null>(null);
  const [ activeTab, setActiveTab] = useState("country");
  const {
      updateLayout 
      } = useConfigLayout({ showCountrySelector: false, 
                         utility: null,
                 showExportButton: false,
                 showBreadCrumb: false});

  useEffect(() => {
    if (data && data.length > 0 && selectedCountry === null) {
      const firstCountryId = data[0].id;
      setSelectedCountry(firstCountryId);
    }
  }, [data, selectedCountry]);
  
  const handleSetSelectedCountry = (id : number) => {
    setSelectedCountry(id);
    setActiveTab("utility")
    updateLayout({
      showBreadCrumb: true,
      country: data?.filter(x => x.id === id)[0] ?? null
    })
  };
  
  useEffect(()=>{
     if (isError) {
      //  toast.error(getErrorMessage(error?.data))
     }
  },[isError, error])

  

  const tabs: TabItem[] = [
    {
      key: 'country',
      label: 'Country',
      content: (
        <CountryTab 
          isLoading={isLoading}
          countries={data ?? []}
          onSelectCountry={handleSetSelectedCountry}
        />
      ),
    },
    {
      key: 'utility',
      label: 'Utility',
      content: <UtilityPage countryLoading={isLoading} selectedCountryId={selectedCountry ?? 0} />,
    }
  ];

  return (
    <BillPageLayout title="Settings">
      <Tabs 
        tabs={tabs} 
        activeTab={activeTab}
        onTabChange={(key) => setActiveTab(key)}
      />
    </BillPageLayout>
  );
};

export default SettingsPage;